import React from "react";
import ClipLoader from "react-spinners/PulseLoader";
import { colors } from "../constants/colors";

const Loader = ({ loading }:any) => {
    const overlayStyle:any = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)", 
        display: loading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999, 
    };

    const spinnerStyle = {
        display: "block",
        borderColor:colors.orange,
    };

    return (
        <div style={overlayStyle}>
            <ClipLoader
                color={colors.orange}
                loading={loading}
                cssOverride={spinnerStyle}
                size={20}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </div>
    );
};

export default Loader;
